import React from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import BaseComponent from "../../base-component";
import {connect} from "react-redux";
import {bindActionCreators} from "redux";
import {galleryDestroy, galleryLoad, galleryUpload} from "../../../gallery/gallery-actions";
import {Form, InputGroup, InputGroupAddon, Modal, Nav, NavItem, NavLink, TabContent, TabPane} from "reactstrap";
import ModalBody from "reactstrap/es/ModalBody";
import ModalFooter from "reactstrap/es/ModalFooter";
import {FormattedMessage} from "react-intl";
import * as DraftJS from "draft-js";
import {Formik} from "formik";
import {displayErrors} from "../../../form-helpers";
import {handleApiResponse} from "../../../crud-actions";
import GalleryItemList from "./gallery-item-list";

class GalleryBrowserComponent extends BaseComponent {

    constructor(params) {
        super(params);

        this.state = {
            open: false,
            activeTab: 'Gallery::Image',
            itemsFilter: '',
            url: ''
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        const previous_filter = prevState.itemsFilter;
        const new_filter = this.state.itemsFilter;

        if (previous_filter !== new_filter && new_filter) {
            this.fetch({q: {}});
        }
    }

    fetch = (filter) => {
        const itemsFilter = this.state.itemsFilter;

        if (itemsFilter) {
            filter['q']['type_eq'] = itemsFilter;
        }

        return this.props.galleryLoad(filter);
    };

    toggle = () => {
        this.setState({ open: !this.state.open });
    };

    toggleTab(tab) {
        if (this.state.activeTab !== tab) {
            this.setState({activeTab: tab});
        }
    }

    uploadItem = (values, form) => {
        const promise = this.props.galleryUpload(values);
        handleApiResponse(
            'GALLERY',
            'UPLOAD',
            promise,
            (response) => {
                form.resetForm();
                this.setState({activeTab: values.type})
            },
            (result) => {
                let errors = result.payload.response.errors;
                form.setErrors(errors);
            },
            (error) => {
                console.log(error);
            }).then(() => {
                form.setSubmitting(false);
            });
    };

    tabClassNames(data) {
        return data;
    }

    addExternalVideo = () => {
        const { editorState, onChange } = this.props;
        onChange(this.props.videoPlugin.addVideo(editorState, { src: this.state.url }));
        this.toggle();
    };

    imageModifier(editorState, src, alt, className) {
        if (DraftJS.RichUtils.getCurrentBlockType(editorState) === 'ATOMIC') {
            return editorState;
        }
        var contentState = editorState.getCurrentContent();
        var contentStateWithEntity = contentState.createEntity('IMAGE', 'IMMUTABLE', { src: src, alt: alt, className: className });
        var entityKey = contentStateWithEntity.getLastCreatedEntityKey();
        return DraftJS.AtomicBlockUtils.insertAtomicBlock(editorState, entityKey, ' ');
    }

    addImage = (image) => {
        const { editorState, onChange, toggle } = this.props;
        onChange(this.imageModifier(editorState, image.url, image.alt, 'img-fluid'));
        this.toggle();
    };

    videoModifier(editorState, src) {
        if (DraftJS.RichUtils.getCurrentBlockType(editorState) === 'ATOMIC') {
            return editorState;
        }
        var contentState = editorState.getCurrentContent();
        var contentStateWithEntity = contentState.createEntity('IDOA_VIDEO', 'IMMUTABLE', src);
        var entityKey = contentStateWithEntity.getLastCreatedEntityKey();
        return DraftJS.AtomicBlockUtils.insertAtomicBlock(editorState, entityKey, ' ');
    }

    addVideo = (video) => {
        const { editorState, onChange } = this.props;
        onChange(this.videoModifier(editorState, { src: video.url }));
        this.toggle();
    };

    changeUrl = (evt) => {
        this.setState({ ...this.state, url: evt.target.value });
    };

    render() {
        const { gallery } = this.props;
        return (
            <span className={this.props.className}>
                <span className={''} onClick={this.toggle}>
                    <FontAwesomeIcon icon={['far', 'paperclip']}/>
                </span>
                <Modal isOpen={this.state.open} size='lg'>
                    <ModalBody>
                        <Nav tabs>
                            <NavItem>
                                <NavLink className={this.tabClassNames({ active: this.state.activeTab === '1' })} onClick={() => { this.toggleTab('1'); }}>
                                    <FontAwesomeIcon icon={['far', 'plus']}/>
                                </NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink className={this.tabClassNames({ active: this.state.activeTab === 'Gallery::Image' })} onClick={() => { this.toggleTab('Gallery::Image'); }}>
                                    <FontAwesomeIcon icon={['far', 'image']}/>
                                </NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink className={this.tabClassNames({ active: this.state.activeTab === 'Gallery::Video' })} onClick={() => { this.toggleTab('Gallery::Video'); }}>
                                    <FontAwesomeIcon icon={['far', 'video']}/>
                                </NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink className={this.tabClassNames({ active: this.state.activeTab === '4' })} onClick={() => { this.toggleTab('4'); }}>
                                    <FontAwesomeIcon icon={['fab', 'vimeo']}/> <FontAwesomeIcon icon={['fab', 'youtube']}/>
                                </NavLink>
                            </NavItem>
                        </Nav>
                        <TabContent activeTab={this.state.activeTab}>
                            <TabPane tabId="1">
                                <div className='mt-3'>
                                    <Formik
                                        onSubmit={this.uploadItem}
                                        initialValues={{ file: undefined, name: '', alt: '', description: '', type: 'Gallery::Image' }}
                                        render={props => (
                                            <form onSubmit={(event) => { event.stopPropagation(); props.handleSubmit(event); }}>
                                                <div className='form-group'>
                                                    <label><FormattedMessage id='app.gallery_items.attribute.type'/></label>
                                                    <select id='type' name='type' className='form-control' value={props.values.type} onChange={props.handleChange}>
                                                        {/*<option value="">-</option>*/}
                                                        <option value="Gallery::Video">Video</option>
                                                        <option value="Gallery::Image">Image</option>
                                                    </select>
                                                    { displayErrors(props.errors, 'type') }
                                                </div>
                                                <div className='form-group'>
                                                    <label><FormattedMessage id='app.gallery_items.attribute.name'/></label>
                                                    <input type='text' id='name' className='form-control' value={props.values.name} onChange={props.handleChange}/>
                                                    { displayErrors(props.errors, 'name') }
                                                </div>
                                                <div className='form-group'>
                                                    <label><FormattedMessage id='app.gallery_items.attribute.alt'/></label>
                                                    <input type='text' id='alt' className='form-control' value={props.values.alt} onChange={props.handleChange}/>
                                                    { displayErrors(props.errors, 'alt') }
                                                </div>
                                                <div className='form-group'>
                                                    <label><FormattedMessage id='app.gallery_items.attribute.description'/></label>
                                                    <textarea id='description' className='form-control' value={props.values.description} onChange={props.handleChange}/>
                                                    { displayErrors(props.errors, 'description') }
                                                </div>
                                                <div className='form-group'>
                                                    <label><FormattedMessage id='app.gallery_items.attribute.file'/></label>
                                                    <input type='file' className='form-control' id="file" name="file" onChange={(event) => { props.setFieldValue("file", event.currentTarget.files[0]); }} onBlur={this.props.handleBlur}/>
                                                    {props.errors.file && <div id="feedback">{props.errors.file}</div>}
                                                </div>
                                                <button type='submit' className='btn btn-primary' disabled={props.isSubmitting}><FontAwesomeIcon icon={['far', 'upload']}/> { this.spinner(props.isSubmitting) }</button>
                                            </form>
                                        )}
                                    />
                                </div>
                            </TabPane>
                            <TabPane tabId="Gallery::Image">
                                <GalleryItemList
                                    itemFilter='Gallery::Image'
                                    onChange={this.props.onChange}
                                    toggle={this.toggle}
                                    editorState={this.props.editorState}
                                    active={this.state.activeTab === 'Gallery::Image'}
                                    addItem={this.addImage}/>
                            </TabPane>
                            <TabPane tabId="Gallery::Video">
                                <GalleryItemList
                                    itemFilter='Gallery::Video'
                                    onChange={this.props.onChange}
                                    toggle={this.toggle}
                                    editorState={this.props.editorState}
                                    active={this.state.activeTab === 'Gallery::Video'}
                                    addItem={this.addVideo}/>
                            </TabPane>
                            <TabPane tabId="4">
                                <div className='mt-3'>
                                    <form>
                                    <div className='form-group'>
                                        <label><FormattedMessage id='app.gallery_items.attribute.external_url'/></label>
                                        <input type="text" className={'form-control'} onChange={this.changeUrl} value={this.state.url}/>
                                    </div>
                                    </form>
                                    <button className={'btn btn-primary'} type="button" onClick={this.addExternalVideo}><FontAwesomeIcon icon={['far', 'paste']}/></button>
                                </div>
                            </TabPane>
                        </TabContent>
                    </ModalBody>
                    <ModalFooter>
                        <button className='btn btn-primary' onClick={this.toggle}><FormattedMessage id='app.actions.cancel'/></button>
                    </ModalFooter>
                </Modal>
            </span>
        );
    }

}

function mapStateToProps(state,ownProps) {
    return {
        gallery: state.gallery
    };
}

function matchDispatchToProps(dispatch){
    return bindActionCreators({
        galleryLoad: galleryLoad,
        galleryUpload: galleryUpload,
        galleryDestroy: galleryDestroy
    }, dispatch);
}

export default connect(mapStateToProps, matchDispatchToProps)(GalleryBrowserComponent);
